import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { SharedModule }                        from '../shared/shared.module';
import { TableModule }                         from '../table/table.module';
import { UKPostcodeAddressesComponent }        from './uk-postcode.addresses.component';
import { UKPostcodePurchaseRequestsComponent } from './uk-postcode.purchase-requests.component';
import { UKPostcodeService }                   from './uk-postcode.service';
import { UKPostcodeSettingsComponent }         from './uk-postcode.settings.component';
import { UKPostcodeStates }                    from './uk-postcode.states';

@NgModule({
  declarations: [
    UKPostcodeAddressesComponent,
    UKPostcodePurchaseRequestsComponent,
    UKPostcodeSettingsComponent
  ],
  entryComponents: [
    UKPostcodeAddressesComponent,
    UKPostcodePurchaseRequestsComponent,
    UKPostcodeSettingsComponent
  ],
  imports: [
    SharedModule,
    TableModule,

    UIRouterModule.forChild({ states: UKPostcodeStates })
  ],
  providers: [
    UKPostcodeService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class UKPostcodeModule {}
